import { usePreviewProgramDomain } from "src/shared/store/program-domain/composables/usePreviewProgramDomain";
import { computed, toValue } from "vue";
export const useQrCodeImageUrl = (url) => {
    const qrCodeImageUrl = computed(() => {
        const urlValue = toValue(url);
        const { previewProgramDomain } = usePreviewProgramDomain();
        if (!previewProgramDomain.value) {
            return null;
        }
        if (!urlValue) {
            return null;
        }
        const qrCodeUrl = new URL(`https://${previewProgramDomain.value.domain}/api/v4/barcode`);
        const qrCodeQueryParams = {
            type: "QR_CODE",
            width: "106",
            height: "106",
            content: urlValue,
            margin_width: 0,
        };
        Object.keys(qrCodeQueryParams).forEach((key) => {
            qrCodeUrl.searchParams.append(key, qrCodeQueryParams[key]);
        });
        return qrCodeUrl.toString();
    });
    return {
        qrCodeImageUrl,
    };
};
